import { defineWorkflow } from './workflow-builder'

/**
 * WF-DSP-01 (FG Destruction — rencana, persetujuan D3, pemindahan ke ZM-01, selesai) — nomor workflow 14, entitas
 * `fg_destruction`. Sumber: TL 12B WF-DSP-01 + BA 12E DSP-01/01A/02 + prototype v7.44. Selisih (laporan 18):
 * - Status awal `DSP_FG_DRAFT` diberi label BA "Perlu Jadwal Ulang": dokumen BA langsung terbit "Menunggu Approval"
 *   (Admin menjadwalkan + mengajukan sekali jalan), jadi Draft hanya dihuni dokumen yang dikembalikan Supervisor.
 * - `ACT_DSP_FG_COMPLETE` boleh dijalankan Admin ATAU Supervisor (BA DSP-01A butir 7; TL hanya Admin).
 * - "Alihkan Sebagian ke Repack" adalah mutasi baris (bukan perpindahan status) — dijalankan handler, tanpa aksi workflow.
 * - Tidak ada Kadiv: regulasi cukai (BA 04 §4.3) — Supervisor satu-satunya approver.
 */
export const WF_DSP_FG = defineWorkflow({
  no: 14,
  code: 'WF-DSP-01',
  name: 'FG Destruction Workflow',
  entity: 'fg_destruction',
  statuses: [
    ['DSP_FG_DRAFT', 'Perlu Jadwal Ulang', true, false, '#64748B', 'Dikembalikan Supervisor, Admin menjadwalkan ulang'],
    ['DSP_FG_PENDING_APP', 'Menunggu Approval', false, false, '#EF4444', 'Menunggu persetujuan rencana (D3)'],
    ['DSP_FG_APPROVED', 'Disetujui', false, false, '#10B981', 'Rencana disetujui, BA Rencana bisa dicetak'],
    ['DSP_FG_ASSIGNED', 'Ditugaskan', false, false, '#06B6D4', 'Tugas pemindahan ke ZM-01 diterbitkan'],
    ['DSP_FG_IN_AREA', 'Di Area Pemusnahan', false, false, '#8B5CF6', 'Barang tiba di ZM-01, siap dimusnahkan'],
    ['DSP_FG_COMPLETED', 'Selesai', false, true, '#059669', 'Pemusnahan selesai, stok keluar permanen']
  ],
  actors: [
    ['ACT_DSP_FG_ADMIN_FG', 'Admin WH FG', 'admin_wh_fg', null],
    ['ACT_DSP_FG_SPV_FG', 'Supervisor WH FG', 'supervisor_wh_fg', null],
    ['ACT_DSP_FG_OP_FG', 'Operator WH FG', 'operator_wh_fg', null]
  ],
  components: [
    ['CMP_DSP_FG_SUBMIT', 'Tombol Terbitkan & Ajukan', 'ACTION', { color: '#EF4444', variant: 'primary' }],
    ['CMP_DSP_FG_APPROVE_D3', 'Tombol Setujui Rencana (D3)', 'ACTION', { color: '#10B981', variant: 'primary' }],
    ['CMP_DSP_FG_RESCHEDULE', 'Tombol Minta Jadwal Ulang', 'ACTION', { variant: 'outlined' }],
    ['CMP_DSP_FG_ASSIGN_MOVE', 'Tombol Terbitkan Tugas Pindah', 'ACTION', {}],
    ['CMP_DSP_FG_ARRIVE_ZM', 'Tombol Konfirmasi Tiba di ZM', 'ACTION', {}],
    ['CMP_DSP_FG_FINISH', 'Tombol Tandai Sudah Dimusnahkan', 'ACTION', {}],
    ['CMP_DSP_FG_PANEL_HEADER', 'Panel Header Pemusnahan FG', 'PANEL', {}],
    ['CMP_DSP_FG_PANEL_PACKS', 'Panel Rincian Pack NG (ZN-01)', 'PANEL', {}],
    ['CMP_DSP_FG_PANEL_BA', 'Panel Berita Acara & Legalitas Cukai', 'PANEL', {}]
  ],
  actions: [
    ['ACT_DSP_FG_SEND', 'DSP_FG_DRAFT', 'DSP_FG_PENDING_APP', 'CMP_DSP_FG_SUBMIT', false, false, null],
    ['ACT_DSP_FG_APP', 'DSP_FG_PENDING_APP', 'DSP_FG_APPROVED', 'CMP_DSP_FG_APPROVE_D3', false, false, null],
    ['ACT_DSP_FG_REVISE', 'DSP_FG_PENDING_APP', 'DSP_FG_DRAFT', 'CMP_DSP_FG_RESCHEDULE', true, true, null],
    ['ACT_DSP_FG_ASSIGN', 'DSP_FG_APPROVED', 'DSP_FG_ASSIGNED', 'CMP_DSP_FG_ASSIGN_MOVE', false, false, null],
    ['ACT_DSP_FG_DELIVER_ZM', 'DSP_FG_ASSIGNED', 'DSP_FG_IN_AREA', 'CMP_DSP_FG_ARRIVE_ZM', false, false, null],
    [
      'ACT_DSP_FG_COMPLETE',
      'DSP_FG_IN_AREA',
      'DSP_FG_COMPLETED',
      'CMP_DSP_FG_FINISH',
      false,
      false,
      { is_destroyed: true, destroyed_at: '$NOW', done_at: '$NOW' }
    ]
  ],
  eligibility: [
    ['ACT_DSP_FG_SEND', 'ACT_DSP_FG_ADMIN_FG'],
    ['ACT_DSP_FG_APP', 'ACT_DSP_FG_SPV_FG'],
    ['ACT_DSP_FG_REVISE', 'ACT_DSP_FG_SPV_FG'],
    ['ACT_DSP_FG_ASSIGN', 'ACT_DSP_FG_ADMIN_FG'],
    ['ACT_DSP_FG_DELIVER_ZM', 'ACT_DSP_FG_OP_FG'],
    ['ACT_DSP_FG_COMPLETE', 'ACT_DSP_FG_ADMIN_FG'],
    ['ACT_DSP_FG_COMPLETE', 'ACT_DSP_FG_SPV_FG']
  ],
  panels: [
    ['CMP_DSP_FG_PANEL_HEADER', 'DSP_FG_DRAFT', 'write', 'ACT_DSP_FG_ADMIN_FG'],
    ['CMP_DSP_FG_PANEL_HEADER', 'DSP_FG_PENDING_APP', 'read', null],
    ['CMP_DSP_FG_PANEL_HEADER', 'DSP_FG_COMPLETED', 'read', null],
    ['CMP_DSP_FG_PANEL_PACKS', 'DSP_FG_DRAFT', 'write', 'ACT_DSP_FG_ADMIN_FG'],
    ['CMP_DSP_FG_PANEL_PACKS', 'DSP_FG_PENDING_APP', 'read', null],
    ['CMP_DSP_FG_PANEL_PACKS', 'DSP_FG_ASSIGNED', 'read', null],
    ['CMP_DSP_FG_PANEL_BA', 'DSP_FG_APPROVED', 'read', null],
    ['CMP_DSP_FG_PANEL_BA', 'DSP_FG_COMPLETED', 'read', null]
  ],
  emailStatuses: ['DSP_FG_PENDING_APP', 'DSP_FG_APPROVED', 'DSP_FG_COMPLETED']
})

export type DspFgStatusCode = (typeof WF_DSP_FG.spec.statuses)[number][0]
export type DspFgActionName = (typeof WF_DSP_FG.spec.actions)[number][0]
export const buildWorkflowDspSeed = WF_DSP_FG.build
